module.exports = __webpack_public_path__ + "img/newsbanner.2aa7d9b3.png";